import styled from "styled-components";
import Button, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";
import { BRAND_DARKEST, GRAY, WHITE } from "@streeteasy/design-system/colors";
import DSCloseButton from "@streeteasy/design-system/deprecated/XButton";
import { SecondarySmall } from "@streeteasy/design-system/typography";

import SEModal from "src/shared/components/SEModal";

const Loading = styled.div`
  padding: 22px;
  text-align: center;
`;

const Modal = styled(SEModal).attrs({
  dialogStyles: {
    left: "50%",
    top: "120px",
    transform: "translateX(-50%)"
  }
})``;

const ModalContainer = styled.div`
  background-color: ${WHITE};
  height: ${({ isLoading }) => (isLoading ? "582px" : "auto")};
  width: ${({ isLoading }) => (isLoading ? "980px" : "auto")};
`;

const ModalHeader = styled(SecondarySmall).attrs({ as: "span" })`
  align-items: center;
  background: ${BRAND_DARKEST};
  color: ${WHITE};
  display: flex;
  height: 52px;
  padding: 0 18px;
  justify-content: space-between;
  top: 0;
  z-index: 999999;
`;

const CloseButton = styled(DSCloseButton)`
  color: ${GRAY};
`;

const ModalHeaderButton = styled(Button).attrs({
  theme: buttonActionThemes.DARK_PRIMARY
})`
  min-width: auto;
`;

CloseButton.displayName = "CloseButton";
Loading.displayName = "Loading";
Modal.displayName = "Modal";
ModalContainer.displayName = "ModalContainer";
ModalHeader.displayName = "ModalHeader";
ModalHeaderButton.displayName = "ModalHeaderButton";

export {
  CloseButton,
  Loading,
  Modal,
  ModalContainer,
  ModalHeader,
  ModalHeaderButton
};
